export default "/static/assets/9dcd70d8bb4975aa.png"